export const wednesdayUppercase = "INqPRe";
export default {wednesdayUppercase};